import errorReporter from "error_reporter"

async function loadMedia(noscript) {
  // Handle jQuery/cash-dom objects
  if (noscript?.length !== undefined) {
    noscript = noscript[0]
  }

  // Return early if not a valid element
  if (!noscript || !(noscript instanceof Element)) return

  // If the element is not a noscript tag, try to find one inside it
  if (noscript.tagName !== "NOSCRIPT") {
    noscript = noscript.querySelector("noscript")
  }
  if (!noscript) return

  try {
    // .trim() because on some browsers the content can be "\n\n"
    // also innerHTML can return undefined
    const html = noscript.textContent?.trim() || noscript.innerHTML?.trim()
    if (!html) return

    const tempDiv = document.createElement("div")
    tempDiv.innerHTML = html
    const children = Array.from(tempDiv.children)
    if (children.length === 0) return

    // Only wait for elements that actually load external resources
    const loadableElements = ["LINK", "SCRIPT", "IMG", "IFRAME"]
    const loadableChildren = children.filter(child =>
      loadableElements.includes(child.tagName)
    )

    const pendingResolvers = new Set()
    function resolveAllPending() {
      Array.from(pendingResolvers).forEach(resolvePending => resolvePending())
      pendingResolvers.clear()
    }

    const loadingPromises = loadableChildren.map(child =>
      new Promise((resolve) => {
        if (child.tagName === "IMG" && child.complete) {
          resolve()
          return
        }

        let settled = false

        function cleanup() {
          child.removeEventListener("load", onLoad)
          child.removeEventListener("error", onError)
          if (child.onload === onLoad) child.onload = null
          if (child.onerror === onError) child.onerror = null
        }

        function finish() {
          if (settled) return
          settled = true
          pendingResolvers.delete(finish)
          cleanup()
          resolve()
        }

        pendingResolvers.add(finish)

        function onLoad() {
          finish()
        }

        function onError(eventOrError) {
          const error = eventOrError instanceof Error ?
            eventOrError :
            new Error("Failed to load media")

          // eslint-disable-next-line no-console
          console.error(error, child)
          errorReporter.warn(error, {html: child?.outerHTML})

          resolveAllPending()
        }

        child.addEventListener("load", onLoad)
        child.addEventListener("error", onError)
        child.onload = onLoad
        child.onerror = onError

        // Fallback timeout to prevent hanging forever
        setTimeout(onLoad, 10000)
      })
    )

    noscript.replaceWith(...children)

    // Wait for all loadable elements to finish loading
    if (loadingPromises.length) {
      await Promise.all(loadingPromises)
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error, noscript)
    errorReporter.warn(error, {
      error: error?.message || error,
      html: noscript?.outerHTML
    })
  }
}

export default loadMedia
